import type { DeliveredListResponse } from '@shared/schemas';
import { all, call, getContext, put, takeLatest } from 'redux-saga/effects';

import type { DiscoveredLpsGateway } from '../infrastructure/discovered-lps.gateway';
import { discoveredLpsRequested } from './discovered-lps.actions';
import { discoveredLpsActions } from './discovered-lps.slice';

const DEFAULT_ERROR = 'Failed to load lists.';

/** Best-effort human message for the failure banner (no domain error union needed). */
function toMessage(e: unknown): string {
  if (e instanceof TypeError) {
    return 'Network error; please check your connection and retry.';
  }
  return e instanceof Error && e.message ? e.message : DEFAULT_ERROR;
}

/** WORKER: fetch the Discovered LPs listing. All I/O via the injected gateway. */
function* fetchDiscoveredLpsWorker() {
  const gateway: DiscoveredLpsGateway = yield getContext('discoveredLpsGateway');
  yield put(discoveredLpsActions.loadStarted());
  try {
    const rows = (yield call(gateway.fetchLists)) as DeliveredListResponse[];
    yield put(discoveredLpsActions.loadSucceeded(rows));
  } catch (e) {
    yield put(discoveredLpsActions.loadFailed(toMessage(e)));
  }
}

/** WATCHERS. */
export function* discoveredLpsSaga() {
  yield all([takeLatest(discoveredLpsRequested.type, fetchDiscoveredLpsWorker)]);
}
